import { theme } from '../../../styles'
import { IModuleBackgroundColorProps } from '../ModuleSection/ModuleSection'

export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: ['center', 'center', 'initial'],
  padding: '20px',
  width: ['100%', '100%', '75%'],
  alignItems: 'center',
}

export const getBackgroundColor = (moduleBackgroundColor: IModuleBackgroundColorProps): Record<string, string[]> => {
  const mobileBackgroundColor = theme.v2.colors[moduleBackgroundColor.mobile || moduleBackgroundColor.desktop]
  const desktopBackgroundColor = theme.v2.colors[moduleBackgroundColor.desktop]

  return { backgroundColor: [mobileBackgroundColor, mobileBackgroundColor, desktopBackgroundColor] }
}
